import { useTranslation } from 'react-i18next';

import { VISUAL_REFRESH } from 'common/utils';

import { CopyButton, DsCopyField } from './components';
import { StyledTextField } from './CopyTextField.styled';

import type { TextInputPosition } from '@natter-co/design-system';

type Props = {
  value: string;
  /**
   * The field's name. The Design System field draws it inside the box and has no unnamed form, so
   * with the visual refresh on a field without one stays on the MUI implementation. The legacy
   * field names its input without drawing a label.
   */
  label?: string;
  /** Names the legacy field without switching it to the floating-label DS field. */
  hiddenLabel?: string;
  /** Refresh-only. `FieldGroup` normally supplies it, to round only the outer corners of a stack. */
  position?: TextInputPosition;
};

export const CopyTextField = ({ value, label, hiddenLabel, position }: Props) => {
  const { t } = useTranslation('common');
  return VISUAL_REFRESH && label ? (
    <DsCopyField value={value} label={label} position={position} />
  ) : (
    <StyledTextField
      value={value}
      fullWidth
      InputProps={{ readOnly: true }}
      inputProps={{ 'aria-label': label ?? hiddenLabel ?? t('clipboard.content') }}
      suffix=<CopyButton value={value} label={label ?? hiddenLabel} />
    />
  );
};
